import { render, staticRenderFns } from "./xeBizInfo.vue?vue&type=template&id=0dff3b97&scoped=true"
import script from "./xeBizInfo.vue?vue&type=script&lang=js"
export * from "./xeBizInfo.vue?vue&type=script&lang=js"
import style0 from "./xeBizInfo.vue?vue&type=style&index=0&id=0dff3b97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff3b97",
  null
  
)

export default component.exports